import * as React from 'react';
import { ThemeTrafficAllocationInput } from '@app/react-common/components/traffic-allocation/ThemeTrafficAllocationInput';
import { TrafficAllocationVariant } from '@app/react-common/components/traffic-allocation/TrafficAllocationShared';
import { Shop } from '@pdqdev/pdq-shared/dist/entities/Shop';
import { AbTestFormData } from '../../AbTestModal';
import useCheckouts from '../../hooks/useCheckouts';

interface ThemesAllocationSectionProps {
  formData: AbTestFormData;
  setFormData: React.Dispatch<React.SetStateAction<AbTestFormData>>;
  setTrafficAllocationValid: (valid: boolean) => void;
  mode: string;
  shop: Shop;
  runningAbTestCheckoutIds: number[];
  isLoading?: boolean;
  isCrossSite?: boolean;
}

export function ThemesAllocationSection({
  formData,
  setFormData,
  setTrafficAllocationValid,
  mode,
  shop,
  runningAbTestCheckoutIds,
  isLoading = false,
  isCrossSite = false,
}: ThemesAllocationSectionProps) {
  const { checkouts } = useCheckouts();

  const handleCheckoutGroupChange = (themeId: string, checkoutGroupIds: number[]) => {
    setFormData((prevData) => ({
      ...prevData,
      abTestVariants: prevData.abTestVariants.map((variant) => {
        // Match null externalId with "null" string, otherwise match by id
        const variantThemeId = variant.widgetExternalId === null ? 'null' : variant.widgetExternalId?.toString();
        return variantThemeId === themeId ? { ...variant, checkoutGroupIds } : variant;
      }),
    }));
  };

  if (isLoading || !formData.abTestVariants?.length) return null;

  return (
    <ThemeTrafficAllocationInput
      trafficAllocationConfig={{
        variants: formData?.abTestVariants,
      }}
      onChange={(valid: boolean, variants: TrafficAllocationVariant[]) => {
        setTrafficAllocationValid(valid);
        if (valid) {
          setFormData((prevData) => ({ ...prevData, abTestVariants: variants }));
        }
      }}
      viewMode={mode === 'view'}
      shop={shop}
      checkouts={checkouts}
      onCheckoutGroupChange={handleCheckoutGroupChange}
      runningAbTestCheckoutIds={runningAbTestCheckoutIds}
      isCrossSite={isCrossSite}
    />
  );
}
